import Footer from "./Footer";
export default function Layout({ children }) {
  return (
    <div className="flex flex-col min-h-screen w-full bg-gradient-to-br from-blue-700 via-blue-900 to-blue-600">
      <div className="flex-grow w-full px-4">
        {children}
      </div>
      <Footer />
    </div>
  );
}